import axios from 'axios';
import config from 'utils/config';
import router from '../router';
import { Message, MessageBox } from 'element-ui';

const instance = axios.create({
    baseURL: config.HOST
});

function goToLogin(url) {
    if (window.location.pathname !== '/login') {
        router.history.replace({
            path: '/login',
            query: { return_url: encodeURIComponent(url) }
        });
    }
}

function goToTemplate() {
    if (window.location.pathname !== '/login') {
        router.history.replace({
            path: '/template/list',
        });
    }
}

//判断是否已有Token
if (config.ACCESS_TOKEN) {
    instance.defaults.headers.Authorization = 'Bearer ' + config.ACCESS_TOKEN;
}
instance.interceptors.response.use(
    function (res) {
        let response = res.data;
        if (
            response.code === 400 ||
            response.code === 401 ||
            response.code === 403
        ) {
            goToLogin(window.location.href);
            Message.error("请重新登录");
        } else if (response.code === 501){
            Message.error("对不起，您暂无权限访问该页面");
            goToTemplate();
        }else if (response.code === 0) {
            return Promise.resolve(response.data);
        } else {
            Message.error(response.errorMessage);
            return Promise.reject(response);
        }
    },
    function () {
        return Promise.resolve({});
    }
);

export default instance;
